var map = {
	"./bs.json": "zCZj",
	"./cs.json": "JV/9",
	"./da.json": "zzCU",
	"./de.json": "c0pc",
	"./el.json": "cnyE",
	"./en.json": "v+p/",
	"./es.json": "8QmU",
	"./et.json": "T7rK",
	"./fi.json": "tJF8",
	"./fr.json": "tUD8",
	"./hr.json": "OZrL",
	"./hu.json": "LiqR",
	"./it.json": "dfKj",
	"./lt.json": "FF6f",
	"./lv.json": "rdPD",
	"./nl.json": "MnaG",
	"./no.json": "ZPup",
	"./pl.json": "9Vpb",
	"./pt.json": "g9qU",
	"./ro.json": "boNv",
	"./ru.json": "ToC0",
	"./sk.json": "8/4b",
	"./sl.json": "yqir",
	"./sq.json": "XNfq",
	"./sr.json": "ZpXY",
	"./sv.json": "m9+Q",
	"./tr.json": "FdPN",
	"./uk.json": "mzfW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xirm";